function customProduct(){
    $('.product').each(function() {
        var product = $(this);
        if($(this).find('.ratings-wrapper').length){
            $(this).find('.p-bottom>div').append($(this).find('.ratings-wrapper'))
        }
        if($(this).find('.flag-discount').length){
            $(this).find('.prices').prepend($(this).find('.price-standard'))
        }
        $(this).find('.p').append('<span class="btn_toggle"></span>')
    });
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});